import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { EmployeeProfile } from './employee-profile';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class EmployeeProfileService {

	taxStatuses: any = [
		{ value: 'w2', name: 'w2' },
		{ value: '1099', name: '1099' }
	];

	statuses: any = [
		{ value: 1, name: 'home' },
		{ value: 2, name: 'work' }
	];

	taxExemptElects: any = [
		{ value: 1, name: '1' },
		{ value: 2, name: '2' },
		{ value: 3, name: '3' },
		{ value: 4, name: '4' },
		{ value: 5, name: '5' },
		{ value: 6, name: '6' },
		{ value: 7, name: '7' },
		{ value: 8, name: '8' }
	];

	termReasons: any = [
		{ value: 'Voluntary', name: 'Voluntary' },
		{ value: 'Involuntary', name: 'Involuntary' },
		{ value: 'Abandon', name: 'Abandon' }
	];

	payRateFreqs: any = [
		{ value: 1, name: 'Per Hour' },
		{ value: 2, name: 'Per Year' }
	];

	contractOrPerms: any = [
		{ value: 1, name: 'Permanent' },
		{ value: 2, name: 'Contractor' }
	];

	salaryOrHourlys: any = [
		{ value: 1, name: 'Hourly' },
		{ value: 2, name: 'Salary' }
	];

	genders: any = [
		{ value: 'M', name: 'Male' },
		{ value: 'F', name: 'Female' }
	];

	titles = [
		{ name: 'Mr.', value: 'Mr.' },
		{ name: 'Mrs.', value: 'Mrs.' },
		{ name: 'Ms.', value: 'Ms.' },
		{ name: 'Dr.', value: 'Dr.' },
	];

	jobCategories: any = [
		{ value: 1, name: 'Housekeeping' },
		{ value: 2, name: 'Laundry' },
		{ value: 3, name: 'Houseman' },
		{ value: 4, name: 'Marketing' },
		{ value: 5, name: 'Developer' },
		{ value: 6, name: 'Database Administrator' },
		{ value: 7, name: 'IT Manager' },
		{ value: 8, name: 'Customer Service' },
		{ value: 9, name: 'Administration' },
		{ value: 10, name: 'Business Development' },
		{ value: 11, name: 'Reservations' },
	];

	jobLevels: any = [
		{ value: 1, name: 'Agent' },
		{ value: 2, name: 'Assistant Supervisor' },
		{ value: 3, name: 'Supervisor' },
		{ value: 4, name: 'Director' },
		{ value: 5, name: 'Executive' },
	];

	listingStatuses = [
		{ name: 'Active', value: 1},
		{ name: 'Terminated', value: 2},
		{ name: 'Quit', value: 3},
	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
		) { }

	urlEndpoint = 'employeeProfiles';
	urlEndpointAll = 'employeeProfilesAll';

	add(employeeProfile: EmployeeProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(employeeProfile));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, employeeProfile);
	}

	update(employeeProfile: EmployeeProfile): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, employeeProfile);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findAllForRequiredFields(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all-profiles`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findAllWithoutPage(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpointAll}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

  findByUserId(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-by-userid/${id}`).pipe(retry({ count: 2, delay: 1500 }));
  }
	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
